import { r as s, h as e, H as i } from "./main-bb89b2f2.js";
import "vue";
const r = "*,:after,:before{border-color:var(--color-neutral-steel-200);border-style:solid;border-width:0;box-sizing:border-box}a{color:inherit;text-decoration:inherit}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}button,input,optgroup,select,textarea{font-feature-settings:inherit;color:inherit;font-family:inherit;font-size:100%;font-variation-settings:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0}blockquote,dd,dl,fieldset,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}fieldset,legend{padding:0}.container,.flex{display:flex}.container{align-items:center;font-family:var(--copytext-font-family);width:100%}.container .slotWrapper{color:var(--status-message-text-default)}.container .slotWrapper.big{font-size:var(--copytext-font-size-small-noctx);line-height:var(--copytext-line-height-small-noctx);margin-left:8px}.container .slotWrapper.small{font-size:var(--copytext-font-size-extra-small-noctx);line-height:var(--copytext-line-height-extra-small-noctx);margin-left:4px}::slotted{color:var(--status-message-text-default)}.static{position:static}.block{display:block}.flex{display:flex}", o = r, n = class {
  constructor(t) {
    s(this, t), this.state = void 0, this.size = "big", this.colorState = "var(--status-message-icon-draft)";
  }
  render() {
    switch (this.state) {
      case "verified":
        this.colorState = "var(--status-message-icon-verified)";
        break;
      case "completedAvailable":
        this.colorState = "var(--status-message-icon-completedAvailable)";
        break;
      case "inProgress":
        this.colorState = "var(--status-message-icon-inProgress)";
        break;
      case "canceledNotAvailable":
        this.colorState = "var(--status-message-icon-canceledNotAvailable)";
        break;
      case "created":
        this.colorState = "var(--status-message-icon-created)";
        break;
      default:
        this.colorState = "var(--status-message-icon-draft)";
        break;
    }
    const t = this.size === "big" ? "24px" : "10px", a = {
      slotWrapper: !0,
      [this.size]: !0
    };
    return e(i, { key: "15d8954bfda995181b901120320b1f081c07e00b" }, e("div", { key: "30463c64839d9c8bd0cee2a6cc3f6929e5aad3db", class: "container" }, e("div", { key: "842ab524b6fd858619254366d885f0d1eb438433" }, e("patternlib-icon", { key: "9d47280142ec8baab5ee5534ea79382082c260e8", iconName: "status-message-inprogress-warning", size: t, color: this.colorState })), e("div", { key: "159653c17b5bf49996d79dfc088d3e5d9368052a", class: a }, e("slot", { key: "dcd1c806db32550504ce304e3c6595dc0731ad48" }))));
  }
};
n.style = o;
export {
  n as patternlib_status_message
};
